import Vue from 'vue'
import App from './App.vue'
import { createPinia, PiniaVuePlugin } from 'pinia'
import './index.css'

Vue.config.productionTip = false
Vue.use(PiniaVuePlugin)

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

new Vue({
  render: (h: (arg0: any) => any) => h(App),
  pinia
}).$mount('#app')
